<template>
  <b-container>
    <div class="alert alert-info">{{ usuario_nombre }} - {{ usuario_email }} - {{ usuario_token }}</div>
    <div class="home w-100" style="margin-top: 80px">
      <div class="">
        <h1>Asistente para el envío de documentación a firmar</h1>
        <div class="mt-3">
          <div v-show="paso === 1">
            <h2>PASO {{ paso }}. Fichero a firmar y firmantes del documento</h2>
            <div class="my-4">
              <b-form-group class="mb-4" label-cols-lg="3" label-class="font-weight-bold pt-0" label="Documento a firmar" label-for="chk-destinatarios" description="">
                <b-input-group prepend="Documento a firmar" class="mb-2">
                  <b-form-file id="file" :ref="'file'" placeholder="Selecciona un fichero" browseText="Buscar" accept=".pdf" v-on:change="handleFileUpload()"></b-form-file>
                </b-input-group>
                <b-input-group prepend="Título" class="mb-2">
                  <b-form-input type="text" placeholder="Indica el título" aria-label="Título" @change="actualizacionesautomaticas" v-model="titulo"></b-form-input>
                </b-input-group>
                <b-input-group prepend="Fecha del documento" class="mb-2">
                  <b-form-datepicker now-button v-model="fechadocumento" labelNoDateSelected="Ninguna fecha seleccionada" @input="actualizacionesautomaticas"></b-form-datepicker>
                </b-input-group>
              </b-form-group>

              <b-form-group label-cols-lg="3" label="Tipo de documento" label-class="font-weight-bold pt-0" class="mb-4" description="">
                <b-form-select v-model="tipologia" :options="optTipologias" value-field="codigo" text-field="descripcion"></b-form-select>
              </b-form-group>

              <!-- <b-form-group
                    class="mb-4"
                    label-cols-lg="3"
                    
                    label-class="font-weight-bold pt-0"
                    label="Selección de destinatarios"
                    label-for="chk-destinatarios"
                    description="Todos los destinatarios recibirán un correo para incluir su firma en el documento"
                >
                    <b-form-checkbox-group size="lg"
                        id="chk-destinatarios"
                        v-model="firmantes"
                        :options="options"
                        value-field="item"
                        text-field="item.nombre"
                        stacked
                    ></b-form-checkbox-group>
                </b-form-group> -->

              <b-form-group label-cols-lg="3" label="Firmantes del documento" label-class="font-weight-bold pt-0" class="mb-4" description="">
                <SeleccionFirmantes v-on:actualizar-firmantes="onActualizarFirmantes"></SeleccionFirmantes>
              </b-form-group>

              <b-form-group
                class="mb-4"
                label-cols-lg="3"
                label-class="font-weight-bold pt-0"
                label="Mensaje personalizado"
                label-for="textarea-cuerpodelcorreo"
                description="Obligatorio. Este texto es común para todos los firmantes del documento y formará parte del mensaje que recibirán a través de la plataforma de firma electrónica.
                    NOTA IMPORTANTE: en la última línea del mensaje siempre aparecerá tu nombre como remitente del correo"
              >
                <b-form-textarea id="textarea-cuerpodelcorreo" v-model="cuerpodelcorreo" :state="cuerpodelcorreo.length >= 10" placeholder="Introduce al menos 10 caracteres" rows="5"></b-form-textarea>
              </b-form-group>
            </div>
            <!-- <div class="mt-3">firmantes: <strong>{{ firmantes }}</strong></div> -->
            <div class="w-100 text-right mb-4">
              <b-button :disabled="file === '' || procesandofichero || !firmantes.length" @click="siguientepaso" class="bgcolor-manusa">
                Siguiente
                <b-icon-arrow-right-circle-fill></b-icon-arrow-right-circle-fill>
              </b-button>
            </div>
          </div>

          <div v-show="paso === 2">
            <h2>PASO {{ paso }}. Personalización de los firmantes del documento</h2>
            <div class="my-4">
              <EdicionDatosFirmante v-for="(f, index) in firmantes" :key="index + '-edf'" :firmante="f" :index="index"> </EdicionDatosFirmante>
            </div>
            <div class="d-flex w-100 justify-content-between mb-4">
              <b-button @click="paso--">
                <b-icon-arrow-left-circle-fill></b-icon-arrow-left-circle-fill>
                Anterior
              </b-button>
              <b-button :disabled="procesandofichero || !firmantes.length || procesandoenvio" @click="siguientepaso" class="bgcolor-manusa">
                Siguiente
                <b-icon-arrow-right-circle-fill></b-icon-arrow-right-circle-fill>
              </b-button>
            </div>
          </div>

          <div v-show="paso === 3">
            <h2>PASO {{ paso }}. Confirmación del envío</h2>
            <div class="my-4">
              <h3>Este es el documento a firmar resultante</h3>
              <div :style="estilooverflow + 'overflow-x: hidden; height: 390px;'" v-if="srcpdf !== ''">
                <pdf class="text-center mx-2" v-for="i in numPages" :key="i" :src="srcpdf" :page="i" style="display: inline-block; width: 230px; height: auto; border: 1px solid gray; margin-right: 1em; margin-bottom: 1em"></pdf>
                <div class="mt-2 text-center">
                  <b-button v-b-modal.modal-1>Ampliar</b-button>
                  <b-modal id="modal-1" :title="titulo">
                    <AbrirPDF :src="srcpdf"></AbrirPDF>
                  </b-modal>
                </div>
              </div>
              <h3>Datos registrados</h3>
              <div class="mb-2">
                <b-row
                  ><b-col cols="2" class="mb-1 font-weight-bold text-right">Título:</b-col><b-col>{{ titulo }}</b-col></b-row
                >
                <b-row
                  ><b-col cols="2" class="mb-1 font-weight-bold text-right">Fecha:</b-col><b-col>{{ fechadocumento }}</b-col></b-row
                >
                <b-row
                  ><b-col cols="2" class="mb-1 font-weight-bold text-right">Tipo:</b-col><b-col>{{ tipologia }}</b-col></b-row
                >
                <b-row
                  ><b-col cols="2" class="mb-1 font-weight-bold text-right">Email:</b-col><b-col>{{ cuerpodelcorreo }}</b-col></b-row
                >
              </div>
              <div>
                <b-form-group v-for="(f, index) in firmantes" :key="'tab' + f.id" class="mx-5" label-cols-sm="4" label-cols-lg="3" :label="'Firmante #' + (index + 1)">
                  <b-card-text>
                    <b-row class="mb-1"
                      ><b-col cols="2" class="font-weight-bold text-right">Nombre:</b-col><b-col>{{ f.nombre }}</b-col></b-row
                    >
                    <b-row class="mb-1"
                      ><b-col cols="2" class="font-weight-bold text-right">Email:</b-col><b-col>{{ f.email }}</b-col></b-row
                    >
                    <b-row class="mb-1"
                      ><b-col cols="2" class="font-weight-bold text-right">Modalidad:</b-col><b-col>{{ f.modalidadfirma.descripcion }}</b-col></b-row
                    >
                    <b-row class="mb-1" v-show="f.mensajeprivado.length"
                      ><b-col cols="2" class="font-weight-bold text-right">Mensaje privado:</b-col><b-col>{{ f.mensajeprivado }}</b-col></b-row
                    >
                    <b-row class="mb-1" v-show="!f.mensajeprivado.length"><b-col cols="2" class="font-weight-bold text-right">Mensaje privado:</b-col><b-col>- No se enviará mensaje privado -</b-col></b-row>
                  </b-card-text>
                </b-form-group>
              </div>
              <!-- <div>
                    <b-card title="Firmantes" class="mx-2">
                        <b-tabs pills card vertical active-nav-item-class="bgcolor-manusa">
                            <b-tab v-for="f in firmantes" :key="'tab'+f.id" :title="f.nombre">
                                <b-card-text>                                    
                                    <b-row class="mb-1"><b-col cols="2" class="font-weight-bold text-right">Email:</b-col><b-col>{{ f.email }}</b-col></b-row>
                                    <b-row class="mb-1"><b-col cols="2" class="font-weight-bold text-right">Modalidad:</b-col><b-col>{{ f.modalidadfirma.descripcion }}</b-col></b-row>
                                    <b-row class="mb-1" v-show="f.mensajeprivado.length"><b-col cols="2" class="font-weight-bold text-right">Mensaje privado:</b-col><b-col>{{ f.mensajeprivado }}</b-col></b-row>
                                    <b-row class="mb-1" v-show="!f.mensajeprivado.length"><b-col cols="2" class="font-weight-bold text-right">Mensaje privado:</b-col><b-col>- No se enviará mensaje privado -</b-col></b-row>
                                </b-card-text>
                            </b-tab>
                        </b-tabs>
                    </b-card>
                </div> -->
            </div>

            <div class="d-flex w-100 justify-content-between mb-4">
              <b-button @click="paso--">
                <b-icon-arrow-left-circle-fill></b-icon-arrow-left-circle-fill>
                Anterior
              </b-button>
              <b-button :disabled="procesandofichero || !firmantes.length || procesandoenvio" @click="siguientepaso" class="bgcolor-manusa">
                ¡Todo correcto! Enviar documento a firmar
                <b-icon-arrow-right-circle-fill></b-icon-arrow-right-circle-fill>
              </b-button>
            </div>
          </div>

          <div v-show="paso === 4">
            <b-jumbotron v-if="file && firmantes.length">
              <template v-slot:header>Documento enviado</template>
              <template v-slot:lead>
                El documento {{ file.name }} ha sido enviado a firmar a las siguientes personas
                <ul>
                  <li v-for="s in firmantes" :key="s.id">{{ s.nombre }}, {{ s.modalidadfirma.nombre }}</li>
                </ul>
              </template>
              <hr class="my-4" />
              <p>¿Qué deseas hacer ahora?</p>
              <b-button class="m-1" variant="primary" href="#" @click="reiniciar">Iniciar un nuevo envío</b-button>
              <b-button class="m-1" variant="success" href="#" @click="verdocumentosenviados">Consultar documentos enviados</b-button>
            </b-jumbotron>
          </div>
        </div>
      </div>
    </div>
  </b-container>
</template>

<script>
import SeleccionFirmantes from '@/components/SeleccionFirmantes.vue';
import EdicionDatosFirmante from '@/components/EdicionDatosFirmante.vue';

import AbrirPDF from '@/components/AbrirPDF.vue';
import pdf from 'vue-pdf';
import { mapState } from 'vuex';

//const IDCEO = 1001
const MODALIDADESDEFIRMASTD = [
  {
    id: 'MAN',
    nombre: 'Manuscrita (sin sello de empresa)',
    descripcion: 'Firma electrónica manuscrita (sin sello de empresa)',
    sello: '',
    certificado: ''
  }
];
const PLANTILLACUERPODELCORREO = 'Se solicita la firma del documento "<nombredelfichero>", con fecha <fechadocumento>.\nPara llevar a cabo la firma electrónica del mismo, se ruega se sigan las instrucciones indicadas.\nAtentamente';
const TIPOLOGIAS = [
  { codigo: 'GENERICO', descripcion: 'Genérico' },
  { codigo: 'CEOGENERICO', descripcion: 'CEO - genérico' },
  { codigo: 'COMGENERICO', descripcion: 'Compras - genérico' },
  { codigo: 'COMCOMODATO', descripcion: 'Compras - Contrato de Comodato' },
  {
    codigo: 'CJAGENERICO',
    descripcion: 'Consejo de Administración - Genérico'
  },
  { codigo: 'CJAACTA', descripcion: 'Consejo de Administración - Acta' },
  {
    codigo: 'CJACERTIFICADO',
    descripcion: 'Consejo de Administración - Certificado'
  },
  { codigo: 'FINGENERICO', descripcion: 'Finanzas - genérico' },
  { codigo: 'ITUGENERICO', descripcion: 'ITxU - genérico' },
  { codigo: 'PEOGENERICO', descripcion: 'Personas - genérico' },
  { codigo: 'PEOCADER', descripcion: 'Personas - CADER' },
  { codigo: 'CMLGENERICO', descripcion: 'Ventas - genérico' },
  { codigo: 'CMLCONTRATO', descripcion: 'Ventas - Contrato comercial' },
  { codigo: 'CMLSERVICIO', descripcion: 'Ventas - Servicio' },
  { codigo: 'OTCGENERICO', descripcion: 'O.T. - Genérico' },
  { codigo: 'OTCCONTRAPLANO', descripcion: 'O.T. - Contraplano' }
  /**/
];
const FIRMANTESESPECIALES = [
  {
    id: 1001,
    email: 'josep.medina@manusa.com',
    nombre: 'Josep Medina',
    tratamiento: 'D.',
    tratamientolargo: 'Don',
    cargo: 'Director General de Grupo Manusa',
    modalidadesdefirma: [
      {
        id: 'CDEMG',
        nombre: 'CD + Sello CEO-MG',
        descripcion: 'Certificado Digital, en representación de Manusa Gest, S.L. + Sello CEO Manusa Gest *',
        representacion: 'en representación de Manusa Gest, S.L.',
        sello: 'SELLOMGCEO.png',
        certificado: 'certificado-0001.pfx'
      },
      {
        id: 'CDEMDS',
        nombre: 'CD + Sello CEO-MDS',
        descripcion: 'Certificado Digital, en representación de Manusa Door System, S.L. + Sello CEO MDS *',
        representacion: 'en representación de Manusa Door System, S.L.',
        sello: 'SELLOMDSCEO.png',
        certificado: 'certificado-0002.pfx'
      },
      {
        id: 'CDEFFX',
        nombre: 'CD + Sello CEO-FFX',
        descripcion: 'Certificado Digital, en representación de Ferroflex, S.L. + Sello CEO Ferroflex *',
        representacion: 'en representación de Ferroflex, S.L.',
        sello: 'SELLOFFXCEO.png',
        certificado: 'certificado-0003.pfx'
      },
      {
        id: 'CDERDR',
        nombre: 'CD + Sello CEO-Redor',
        descripcion: 'Certificado Digital, en representación de Redor, S.L. + Sello CEO Redor *',
        representacion: 'en representación de Redor, S.L.',
        sello: 'SELLORDRCEO.png',
        certificado: 'certificado-0004.pfx'
      }
    ],
    mensajeprivado: ''
  },
  {
    id: 1002,
    email: 'jordi.carrasco@manusa.com',
    nombre: 'Jordi Carrasco',
    tratamiento: 'D.',
    tratamientolargo: 'Don',
    cargo: 'Director de IT Grupo Manusa',
    modalidadesdefirma: [
      {
        id: 'MANMG',
        nombre: 'Manuscrita + Sello MG',
        descripcion: 'Firma electrónica manuscrita + Sello Manusa Gest *',
        representacion: '',
        sello: 'SELLOMG.png',
        certificado: ''
      },
      {
        id: 'MANMDS',
        nombre: 'Manuscrita + Sello MDS',
        descripcion: 'Firma electrónica manuscrita + Sello MDS *',
        representacion: '',
        sello: 'SELLOMDS.png',
        certificado: ''
      },
      {
        id: 'MANFFX',
        nombre: 'Manuscrita + Sello FFX',
        descripcion: 'Firma electrónica manuscrita + Sello Ferroflex *',
        representacion: '',
        sello: 'SELLOFFX.png',
        certificado: ''
      },
      {
        id: 'MANRDR',
        nombre: 'Manuscrita + Sello Redor',
        descripcion: 'Firma electrónica manuscrita + Sello Redor *',
        representacion: '',
        sello: 'SELLORDR.png',
        certificado: ''
      },
      {
        id: 'MAN',
        nombre: 'Manuscrita (sin sello de empresa)',
        descripcion: 'Firma electrónica manuscrita (sin sello de empresa)',
        representacion: '',
        sello: '',
        certificado: ''
      }
    ]
  },
  {
    id: 1003,
    email: 'ingrid.castell@manusa.com',
    nombre: 'Ingrid Castell',
    tratamiento: 'Dña.',
    tratamientolargo: 'Doña',
    cargo: 'Directora de RRHH Grupo Manusa',
    modalidadesdefirma: [
      {
        id: 'CDPMG',
        nombre: 'Certificado Digital personal + Sello MG',
        descripcion: 'Certificado Digital personal + Sello Manusa Gest *',
        representacion: '',
        sello: 'SELLOINGRIDCASTELLMG.png',
        certificado: ''
      },
      {
        id: 'CDPMDS',
        nombre: 'Certificado Digital personal + Sello MDS',
        descripcion: 'Certificado Digital personal + Sello MDS *',
        representacion: '',
        sello: 'SELLOINGRIDCASTELLMDS.png',
        certificado: ''
      },
      {
        id: 'CDPFFX',
        nombre: 'Certificado Digital personal + Sello FFX',
        descripcion: 'Certificado Digital personal + Sello Ferroflex *',
        representacion: '',
        sello: 'SELLOINGRIDCASTELLFFX.png',
        certificado: ''
      },
      {
        id: 'CDPRDR',
        nombre: 'Certificado Digital personal + Sello Redor',
        descripcion: 'Certificado Digital personal + Sello Redor *',
        representacion: '',
        sello: 'SELLOINGRIDCASTELLRDR.png',
        certificado: ''
      },
      {
        id: 'MAN',
        nombre: 'Manuscrita (sin sello de empresa)',
        descripcion: 'Firma electrónica manuscrita (sin sello de empresa)',
        representacion: '',
        sello: '',
        certificado: ''
      }
    ]
  },
  {
    id: 1004,
    email: 'eulalia.vallmitjana@manusa.com',
    nombre: 'Eulalia Vallmitjana',
    tratamiento: 'Dña.',
    tratamientolargo: 'Doña',
    cargo: 'Directora de Finanzas Grupo Manusa',
    modalidadesdefirma: [
      {
        id: 'CDPMG',
        nombre: 'Certificado Digital personal + Sello MG',
        descripcion: 'Certificado Digital personal + Sello Manusa Gest *',
        representacion: '',
        sello: 'SELLOEULALIAVALLMITJANAMG.png',
        certificado: ''
      },
      {
        id: 'CDPMDS',
        nombre: 'Certificado Digital personal + Sello MDS',
        descripcion: 'Certificado Digital personal + Sello MDS *',
        representacion: '',
        sello: 'SELLOEULALIAVALLMITJANAMDS.png',
        certificado: ''
      },
      {
        id: 'CDPFFX',
        nombre: 'Certificado Digital personal + Sello FFX',
        descripcion: 'Certificado Digital personal + Sello Ferroflex *',
        representacion: '',
        sello: 'SELLOIEULALIAVALLMITJANAFFX.png',
        certificado: ''
      },
      {
        id: 'CDPRDR',
        nombre: 'Certificado Digital personal + Sello Redor',
        descripcion: 'Certificado Digital personal + Sello Redor *',
        representacion: '',
        sello: 'SELLOEULALIAVALLMITJANARDR.png',
        certificado: ''
      },
      {
        id: 'MAN',
        nombre: 'Manuscrita (sin sello de empresa)',
        descripcion: 'Firma electrónica manuscrita (sin sello de empresa)',
        representacion: '',
        sello: '',
        certificado: ''
      }
    ]
  },
  {
    id: 1005,
    email: 'aiko.cadena@manusa.com',
    nombre: 'Aiko Cadena',
    tratamiento: 'Dña.',
    tratamientolargo: 'Doña',
    cargo: 'Directora de Marketing Grupo Manusa',
    modalidadesdefirma: [
      {
        id: 'MANMG',
        nombre: 'Manuscrita + Sello MG',
        descripcion: 'Firma electrónica manuscrita + Sello Manusa Gest *',
        representacion: '',
        sello: 'SELLOMG.png',
        certificado: ''
      },
      {
        id: 'MANMDS',
        nombre: 'Manuscrita + Sello MDS',
        descripcion: 'Firma electrónica manuscrita + Sello MDS *',
        representacion: '',
        sello: 'SELLOMDS.png',
        certificado: ''
      },
      {
        id: 'MANFFX',
        nombre: 'Manuscrita + Sello FFX',
        descripcion: 'Firma electrónica manuscrita + Sello Ferroflex *',
        representacion: '',
        sello: 'SELLOFFX.png',
        certificado: ''
      },
      {
        id: 'MANRDR',
        nombre: 'Manuscrita + Sello Redor',
        descripcion: 'Firma electrónica manuscrita + Sello Redor *',
        representacion: '',
        sello: 'SELLORDR.png',
        certificado: ''
      },
      {
        id: 'MAN',
        nombre: 'Manuscrita (sin sello de empresa)',
        descripcion: 'Firma electrónica manuscrita (sin sello de empresa)',
        representacion: '',
        sello: '',
        certificado: ''
      }
    ]
  },
  {
    id: 1006,
    email: 'caspar.vanrijn@manusa.com',
    nombre: 'Caspar Van Rijn',
    tratamiento: 'D.',
    tratamientolargo: 'Don',
    cargo: 'Director de Exportación Grupo Manusa',
    modalidadesdefirma: [
      {
        id: 'MANMG',
        nombre: 'Manuscrita + Sello MG',
        descripcion: 'Firma electrónica manuscrita + Sello Manusa Gest *',
        representacion: '',
        sello: 'SELLOMG.png',
        certificado: ''
      },
      {
        id: 'MANMDS',
        nombre: 'Manuscrita + Sello MDS',
        descripcion: 'Firma electrónica manuscrita + Sello MDS *',
        representacion: '',
        sello: 'SELLOMDS.png',
        certificado: ''
      },
      {
        id: 'MANFFX',
        nombre: 'Manuscrita + Sello FFX',
        descripcion: 'Firma electrónica manuscrita + Sello Ferroflex *',
        representacion: '',
        sello: 'SELLOFFX.png',
        certificado: ''
      },
      {
        id: 'MANRDR',
        nombre: 'Manuscrita + Sello Redor',
        descripcion: 'Firma electrónica manuscrita + Sello Redor *',
        representacion: '',
        sello: 'SELLORDR.png',
        certificado: ''
      },
      {
        id: 'MAN',
        nombre: 'Manuscrita (sin sello de empresa)',
        descripcion: 'Firma electrónica manuscrita (sin sello de empresa)',
        representacion: '',
        sello: '',
        certificado: ''
      }
    ]
  },
  {
    id: 1007,
    email: 'angel.ortega@manusa.com',
    nombre: 'Angel Ortega',
    tratamiento: 'D.',
    tratamientolargo: 'Don',
    cargo: 'Técnico Transformación Digital',
    modalidadesdefirma: [
      {
        id: 'CDEMG',
        nombre: 'CD + Sello MG',
        descripcion: 'Certificado Digital, en representación de Manusa Gest, S.L. + Sello Manusa Gest *',
        representacion: 'en representación de Manusa Gest, S.L.',
        sello: 'SELLOMG.png',
        certificado: 'certificado-0001.pfx'
      },
      {
        id: 'CDEMDS',
        nombre: 'CD + Sello MDS',
        descripcion: 'Certificado Digital, en representación de Manusa Door System, S.L. + Sello MDS *',
        representacion: 'en representación de Manusa Door System, S.L.',
        sello: 'SELLOMDS.png',
        certificado: 'certificado-0002.pfx'
      },
      {
        id: 'CDEFFX',
        nombre: 'CD + Sello FFX',
        descripcion: 'Certificado Digital, en representación de Ferroflex, S.L. + Sello Ferroflex *',
        representacion: 'en representación de Ferroflex, S.L.',
        sello: 'SELLOFFX.png',
        certificado: 'certificado-0003.pfx'
      },
      {
        id: 'CDERDR',
        nombre: 'CD + Sello Redor',
        descripcion: 'Certificado Digital, en representación de Redor, S.L. + Sello Redor *',
        representacion: 'en representación de Redor, S.L.',
        sello: 'SELLORDR.png',
        certificado: 'certificado-0004.pfx'
      },
      {
        id: 'MANMG',
        nombre: 'Manuscrita + Sello MG',
        descripcion: 'Firma electrónica manuscrita + Sello Manusa Gest *',
        representacion: '',
        sello: 'SELLOMG.png',
        certificado: ''
      },
      {
        id: 'MANMDS',
        nombre: 'Manuscrita + Sello MDS',
        descripcion: 'Firma electrónica manuscrita + Sello MDS *',
        representacion: '',
        sello: 'SELLOMDS.png',
        certificado: ''
      },
      {
        id: 'MANFFX',
        nombre: 'Manuscrita + Sello FFX',
        descripcion: 'Firma electrónica manuscrita + Sello Ferroflex *',
        representacion: '',
        sello: 'SELLOFFX.png',
        certificado: ''
      },
      {
        id: 'MANRDR',
        nombre: 'Manuscrita + Sello Redor',
        descripcion: 'Firma electrónica manuscrita + Sello Redor *',
        representacion: '',
        sello: 'SELLORDR.png',
        certificado: ''
      },
      {
        id: 'MAN',
        nombre: 'Manuscrita (sin sello de empresa)',
        descripcion: 'Firma electrónica manuscrita (sin sello de empresa)',
        representacion: '',
        sello: '',
        certificado: ''
      }
    ],
    mensajeprivado: ''
  }
];
var BASE64_MARKER = ';base64,';

function convertDataURIToBinary(dataURI) {
  var base64Index = dataURI.indexOf(BASE64_MARKER) + BASE64_MARKER.length;
  var base64 = dataURI.substring(base64Index);
  var raw = window.atob(base64);
  var rawLength = raw.length;
  var array = new Uint8Array(new ArrayBuffer(rawLength));

  for (var i = 0; i < rawLength; i++) {
    array[i] = raw.charCodeAt(i);
  }
  return array;
}

export default {
  name: 'EnvioDocs',
  computed: {
    ...mapState(['user']),
    usuario_nombre: {
      get() {
        if (!this.user) return '';
        console.log('get', this.user);
        return this.user.nombre;
      }
    },
    usuario_token: {
      get() {
        if (!this.user) return '';
        return this.user.token;
      }
    },
    usuario_email: {
      get() {
        if (!this.user) return '';
        return this.user.email;
      }
    }
  },
  components: {
    pdf,
    SeleccionFirmantes,
    EdicionDatosFirmante,
    AbrirPDF
  },
  data() {
    return {
      procesandofichero: false,
      procesandoenvio: false,
      documentoenviado: false,
      usarplantilla: true,
      paso: 1,
      file: '',
      firmantes: [],
      titulo: '',
      fechadocumento: '',
      tipologia: '',
      cuerpodelcorreo: '',
      optTipologias: [],
      urlpdf: '',
      numPages: undefined,
      srcpdf: '',
      estilooverflow: 'overflow-y: auto;'
    };
  },
  mounted() {
    this.$store.commit('SET_SECCION', 'Documentos varios');
    console.log('this.$store.getters', this.$store.getters);
    this.reiniciar();
  },
  methods: {
    /**
     * @description Busca un firmante especial por email
     * @param {String} email
     * @returns {Object} el elemento encontrado o nulo si no existe
     */
    buscarfirmantePorEmail(email) {
      let f = FIRMANTESESPECIALES.filter((fd) => fd.email === email);
      if (f.length) return f[0];
      return null;
    },
    /**
     * @description Busca un firmante especial por Id
     * @param {Number} id
     * @returns {Object} el elemento encontrado o nulo si no existe
     */
    buscarfirmantePorId(id) {
      let f = FIRMANTESESPECIALES.filter((fd) => fd.id === id);
      if (f.length) return f[0];
      return null;
    },
    /**
     * @description: Trigger que se ejecuta cuando hay un cambio en el array devuelto por el tag SeleccionFirmantes
     * @param {Array} nuevaSeleccion
     */
    onActualizarFirmantes: function (nuevaSeleccion) {
      console.log('onActualizarFirmantes - inicio', nuevaSeleccion);
      // se inicializa el array de firmantes
      this.firmantes = [];
      // por cada elemento devuelto por el tag...
      nuevaSeleccion.forEach((v, index) => {
        console.log('nuevaSeleccion.forEach', v);
        // solo se procesarán los usuarios nuevos (no tienen modalidadfirma)

        // se busca en FIRMANTESESPECIALES
        let f = this.buscarfirmantePorEmail(v.email);
        console.log(v.email, f);
        if (!f) {
          // No es un usuario especial
          f = {
            id: index,
            email: v.email,
            nombre: v.nombre,
            cargo: v.cargo,
            representacion: v.representacion,
            modalidadesdefirma: MODALIDADESDEFIRMASTD,
            tratamiento: '',
            tratamientolargo: ''
          };
        } else {
          f.representacion = f.modalidadesdefirma[0].representacion;
        }

        // Por defecto, se desactiva el editor de datos del firmante
        f.editardatos = false;
        // Por defecto, se toma el primer tipo de modalidad disponible para el usuario
        f.modalidadfirma = f.modalidadesdefirma[0];
        // Por defecto, no hay mensaje privado
        f.mensajeprivado = '';
        // // Se prepara el formato de items para su uso en el CHK, en la fase en la que puede redefinirse los datos de un firmante
        // f.itesmodalidadfirma = []
        // f.modalidadesdefirma.forEach(mdf => {
        //     f.itesmodalidadfirma.push({ item: mdf })
        // })

        // Finalmente, se guarda en el array el nuevo firmante
        this.firmantes.push(f);
      });
      console.log('onActualizarFirmantes - fin', this.firmantes);
    },
    /**
     * @description: Trigger que se ejecuta cuando se detecta algún cambio en algún campo, que implica a su vez la actualización de otros
     */
    actualizacionesautomaticas() {
      if (!this.titulo.length && this.file !== '') this.titulo = this.file.name.split('.')[0];
      if (this.usarplantilla) {
        this.cuerpodelcorreo = PLANTILLACUERPODELCORREO;
        if (this.usuario_nombre.length) this.cuerpodelcorreo = this.cuerpodelcorreo.replace('<remitente>', this.usuario_nombre);
        if (this.titulo.length) this.cuerpodelcorreo = this.cuerpodelcorreo.replace('<nombredelfichero>', this.titulo);
        if (this.fechadocumento.length) this.cuerpodelcorreo = this.cuerpodelcorreo.replace('<fechadocumento>', this.$moment(this.fechadocumento).format('LL'));
      }
    },
    /**
     * @description: Se ejecuta al iniciar un nuevo proceso de firma; inicializa todos los datos a excepción de los destinatarios
     */
    reiniciar() {
      // Se inicializan las variables de estado
      this.procesandofichero = false;
      this.procesandoenvio = false;
      this.documentoenviado = false;
      this.paso = 1;
      this.usarplantilla = true;

      // Se preparan las opciones de Tipologias para el select
      this.optTipologias = TIPOLOGIAS;

      // Se inicializan las propiedades del documento
      this.file = '';
      this.cuerpodelcorreo = '';
      this.titulo = '';
      this.fechadocumento = this.$moment().format();
      this.tipologia = this.optTipologias[0].codigo;
      ////console.log("this.$store.state.user", this.$store.state.user)

      // [TODO] Se inicializa el listado de firmantes
      //   dependiendo del tipo de documento, podrían incluirse,
      //   de forma automática, unos firmantes específicos
      //      p.e. this.onActualizarFirmantes([{'email':'josep.medina@manusa.com'}])

      // Se refrescan los campos automáticos
      this.actualizacionesautomaticas();
    },
    obtenerDescripcionTipologiaSegunCodigo(codigo) {
      console.log(codigo, TIPOLOGIAS);
      return TIPOLOGIAS.filter((t) => t.codigo === codigo)[0].descripcion;
    },
    verdocumentosenviados() {
      alert('En desarrollo');
    },
    /**
     * @description: Trigger que se ejecuta cuando se selecciona un nuevo documento, con el fin de extraer el título del documento
     */
    handleFileUpload() {
      console.log(this.$refs);
      this.file = this.$refs.file.$refs.input.files[0];
      if (!this.titulo.length) {
        this.titulo = this.file.name.split('.')[0];
        this.actualizacionesautomaticas();
      }
      console.log(this.file);
    },
    /**
     * @description: Proceso que envía a API-EFIRMA el documento, los firmantes y otros datos tales como el remitente y tipología.
     *                  El objetivo es que devuelva un PDF generado a partir de los datos enviados, para que sea validado antes de su envío
     */
    generarDocumentoEFirma() {
      //Se marca el estado procesandofichero (hasta que vuelva a false debe estar 'congelado')
      this.procesandofichero = true;
      //Preparación de los datos
      var _t = this;
      //this.axios.defaults.baseURL = process.env.VUE_APP_API_URL
      var formData = new FormData();
      formData.append('documentosoriginales', this.file);
      formData.append('departamento', this.departamento);
      formData.append('tipologia_codigo', this.tipologia);
      formData.append('tipologia_descripcion', this.obtenerDescripcionTipologiaSegunCodigo(this.tipologia));
      formData.append('nombrefichero', this.$moment(this.fechadocumento).format('YYYYMMDDHHmmss') + '.' + this.file.name);
      this.firmantes.forEach((f, i) => {
        formData.append('firmante' + (i + 1) + '_nombre', f.nombre);
        formData.append('firmante' + (i + 1) + '_email', f.email);
        formData.append('firmante' + (i + 1) + '_cargo', f.cargo);
        formData.append('firmante' + (i + 1) + '_representacion', f.representacion);
        formData.append('firmante' + (i + 1) + '_mensajeprivado', f.mensajeprivado);
        formData.append('firmante' + (i + 1) + '_sello', f.modalidadfirma.sello);
        formData.append('firmante' + (i + 1) + '_digital_certificate_name', f.modalidadfirma.certificado);
      });
      const url = '/api/489e939af6e943c2b9324fc27d16256816cce60abe0b4e0db95b0054a591eca89e627a37400a4feba8ba94b8763cc295/efirma/accion';
      this.axios
        .post('efirma/generar-documento-efirma', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
            //'Authorization': `Bearer ${token_dev}`
          }
        })
        .then(function (response) {
          console.log('Respuesta API', response.data);
          if (response.data.error === '') _t.paso++;
          _t.urlpdf = 'data:application/pdf;base64,' + response.data.contenidopdffinal;
          console.log(_t.urlpdf);
          var pdfAsArray = convertDataURIToBinary(_t.urlpdf);
          _t.srcpdf = pdf.createLoadingTask(pdfAsArray);
          _t.srcpdf.promise.then((pdf) => {
            console.log('pdf', pdf);
            _t.numPages = pdf.numPages;
            if (_t.numPages < 4) _t.estilooverflow = 'overflow-y: hidden;';
          });
        })
        .catch(function (error) {
          console.log(error);
        })
        .then(function () {
          _t.procesandofichero = false;
          // always executed
        });
    },
    /**
     * @description: Confirma el envío, de modo que se pasa por json toda la información editada
     *              (remitente, texto email, tipología, firmantes), incluido el PDF (en base64)
     *              que se ha obtenido en el paso anterior.
     */
    confirmarEnvio() {
      this.procesandoenvio = true;

      //Preparación de los datos
      var _t = this;
      //this.axios.defaults.baseURL = process.env.VUE_APP_API_URL
      var formData = new FormData();
      formData.append('datapdf', this.urlpdf);
      formData.append('tipologia_codigo', this.tipologia);
      formData.append('tipologia_descripcion', this.obtenerDescripcionTipologiaSegunCodigo(this.tipologia));
      formData.append('titulo', this.titulo);
      formData.append('asunto', 'Firma del documento ' + this.titulo);
      formData.append('cuerpodelcorreo', this.cuerpodelcorreo);
      formData.append('signing_mode', 'parallel');
      formData.append('remitente_nombre', this.usuario_nombre);
      formData.append('remitente_email', this.usuario_email);
      formData.append('nombrefichero', this.$moment(this.fechadocumento).format('YYYYMMDDHHmmss') + '.' + this.file.name);
      formData.append('numerofirmantes', this.firmantes.length);
      this.firmantes.forEach((f, i) => {
        formData.append('firmante' + (i + 1) + '_nombre', f.nombre);
        formData.append('firmante' + (i + 1) + '_email', f.email);
        formData.append('firmante' + (i + 1) + '_cargo', f.cargo);
        formData.append('firmante' + (i + 1) + '_representacion', f.representacion);
        formData.append('firmante' + (i + 1) + '_mensajeprivado', f.mensajeprivado);
        formData.append('firmante' + (i + 1) + '_sello', f.modalidadfirma.sello);
        formData.append('firmante' + (i + 1) + '_digital_certificate_name', f.modalidadfirma.certificado);
      });
      const url = '/api/489e939af6e943c2b9324fc27d16256816cce60abe0b4e0db95b0054a591eca89e627a37400a4feba8ba94b8763cc295/efirma/accion';
      this.axios
        .post('efirma/enviar-documento-efirma', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${this.usuario_token}`
          }
        })
        .then(function (response) {
          console.log('Respuesta API', response.data);
          if (response.data.error === '') {
            _t.paso++;
          }
        })
        .catch(function (error) {
          console.log(error);
        })
        .then(function () {
          _t.procesandoenvio = false;
          // always executed
        });
    },
    /**
     * @description: cada nuevo paso tiene una acción asociada; si la acción se desarrolla correctamente, avanza de página.
     */
    siguientepaso() {
      console.log('Entra con paso ' + this.paso);
      switch (this.paso) {
        case 1:
          console.log('fichero', this.file);
          this.paso++;
          break;
        case 2:
          this.generarDocumentoEFirma();
          break;
        case 3:
          this.confirmarEnvio();
          break;
      }
      console.log('Sale con paso ' + this.paso);
    },
    enviarDocumentoParaFirmar() {
      const MARGINIZQ = 35;
      var posT = 50;
      var posL = MARGINIZQ;
      var idR = 0;

      console.log('Iniciando envío del documento a Signaturit');
      var formData = new FormData();
      this.firmantes.forEach((s) => {
        formData.append('recipients[' + idR + '][name]', s.nombre);
        formData.append('recipients[' + idR + '][email]', s.email);
        if (s.modalidadfirma.id === 'MANUSCRITA') {
          //FIRMA
          formData.append('recipients[' + idR + '][widgets][0][page]', this.numPages);
          formData.append('recipients[' + idR + '][widgets][0][left]', posL);
          formData.append('recipients[' + idR + '][widgets][0][top]', posT);
          formData.append('recipients[' + idR + '][widgets][0][type]', 'signature');
          formData.append('recipients[' + idR + '][widgets][0][width]', '30');
          formData.append('recipients[' + idR + '][widgets][0][height]', '9');

          //NOMBRE DEL FIRMANTE
          formData.append('recipients[' + idR + '][widgets][1][page]', this.numPages);
          formData.append('recipients[' + idR + '][widgets][1][left]', posL);
          formData.append('recipients[' + idR + '][widgets][1][top]', posT + 9);
          formData.append('recipients[' + idR + '][widgets][1][type]', 'text-area');
          formData.append('recipients[' + idR + '][widgets][1][width]', '30');
          formData.append('recipients[' + idR + '][widgets][1][height]', '4');
          formData.append('recipients[' + idR + '][widgets][1][editable]', false);
          formData.append('recipients[' + idR + '][widgets][1][default]', 'FDO. ' + s.tratamiento + ' ' + s.nombre + '\n' + s.cargo + '\n' + s.modalidadfirma.nombre);

          // el siguiente va a la derecha del primero
          posL += 40;
          // solo pueden haber dos por fila; si hay un segundo, se pasa
          if (posL > 80) {
            posL = MARGINIZQ;
            posT += 15;
          }
        } else {
          formData.append('recipients[' + idR + '][sign_with_digital_certificate_file]', 1);
          formData.append('recipients[' + idR + '][digital_certificate_name]', s.modalidadfirma.certificado);
        }

        idR++;
      });

      //var fs = require("fs")
      const token_dev = ''; //DESACTIVADO
      formData.append('files[0]', this.file);
      formData.append('subject', 'Firma del documento ' + this.titulo);
      formData.append('body', this.cuerpodelcorreo);
      formData.append('remitente', this.usuario_nombre);
      formData.append('signing_mode', 'parallel');
      formData.append('cc[0][email]', 'angel.ortega@manusa.com');
      formData.append('cc[0][name]', 'Angel Ortega');
      console.log(formData);

      const url = '/api/489e939af6e943c2b9324fc27d16256816cce60abe0b4e0db95b0054a591eca89e627a37400a4feba8ba94b8763cc295/efirma/accion';
      var _t = this;
      this.axios
        .post('//api.sandbox.signaturit.com/v3/signatures.json', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${token_dev}`
          }
        })
        .then(function (response) {
          console.log('Respuesta Signaturit', response);
          _t.documentoenviado = true;
          _t.procesandoenvio = true;
          _t.paso++;
        })
        .catch(function (error) {
          console.log(error);
        })
        .then(function () {
          // always executed
        });
    }
  }
};
</script>
<style scoped>
h1 {
  font-size: 1.5em;
  color: var(--color-manusa-azul);
}
h2 {
  font-size: 1.4em;
  background-color: #c4de45;
  padding: 0.2em 1em;
  color: black;
  border-radius: 1em;
}
h3 {
  font-size: 1.3em;
  color: #eb3d77;
}
.badge-info {
  background-color: #4256f9 !important;
  color: white;
}
.btn-outline-secondary:hover {
  color: #fff !important;
  background-color: #1d6db5 !important;
  border-color: #1d6db5 !important;
}
</style>
